import { useQuery } from "@tanstack/react-query"
import type { PropertyResponse } from "@zplanem/responses"
import { ApiError, apiFetch } from "../../lib/api-client"
import { queryKeys } from "../../lib/query-keys"

export function useProperty(id: string | undefined) {
	return useQuery({
		queryKey: id ? queryKeys.property(id) : ["properties", "__nil__"],
		queryFn: () =>
			apiFetch<PropertyResponse>(`/api/common/properties/${id}`).then(
				(res) => res.property,
			),
		enabled: !!id,
		retry: (failureCount, error) => {
			// 404s are terminal — the property doesn't exist or the caller has no
			// access. Falling through to TanStack's default retry would just hammer
			// the API. Surface as error immediately.
			if (error instanceof ApiError && error.status === 404) return false
			return failureCount < 3
		},
	})
}
